const initialState = [];

function pageActionsReducer(state = initialState, action) {
  switch (action.type) {
    case "pageActions/update":
      return action.payload;
    default:
      return state;
  }
}

export default pageActionsReducer;
